import axiosInstance from "./axiosInstance";

export const createDisposal = async ({ product_id, qty, reason = "" }) => {
  const res = await axiosInstance.post("/pos/disposals", { product_id, qty, reason });
  return res.data;
};

export const fetchDisposals = async ({
  page = 1,
  limit = 10,
  search = "",
  startDate = "",
  endDate = "",
  branchId = "",
} = {}) => {
  const res = await axiosInstance.get("/pos/disposals", {
    params: { page, limit, search, startDate, endDate, branch_id: branchId || undefined },
  });
  return res.data;
};
